import { render, staticRenderFns } from "./Masters.vue?vue&type=template&id=6c87c27b&scoped=true&"
import script from "./Masters.vue?vue&type=script&lang=js&"
export * from "./Masters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c87c27b",
  null
  
)

export default component.exports